import styled from '@emotion/styled'

export const BalanceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 32px;
`

export const SkeletonGridContainer = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(3, 1fr);
  margin-bottom: 16px;
`
